import { useAuth } from "../auth/use-auth.js";
import type { TableCallParticipantDirectory } from "./table-call-participant-directory.js";
import type { MeetingClient } from "./table-call.context.js";
import { useTableCallSpeakingTracker } from "./use-table-call-speaking-tracker.js";

export const TableCallSpeakingTracker = ({
  meeting,
  participantDirectory,
  microphoneActive,
  tableId,
}: {
  meeting: MeetingClient | null;
  participantDirectory: TableCallParticipantDirectory;
  microphoneActive: boolean;
  tableId: string | null;
}) => {
  const { user } = useAuth();
  useTableCallSpeakingTracker({
    meeting,
    participantDirectory,
    selfMicrophoneActive: microphoneActive,
    selfUserId: user.id,
    tableId,
  });
  return null;
};
